//
//
//
//
//
//
//
//
//
//
//
//

import InlineSpinner from '@/components/common/InlineSpinner.vue';

export default {
  name: 'PwrSubmit',
  props: {
    submitText: {
      type: String,
      default: 'Submit',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'primary',
    },
  },
  computed: {
    buttonText() {
      return this.loading ? '' : this.submitText;
    },
  },
  components: {
    InlineSpinner,
  },
};
